/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CargoAdminDto } from '../models/CargoAdminDto';
import type { CargoDriverDto } from '../models/CargoDriverDto';
import type { CargoStatus } from '../models/CargoStatus';
import type { GetCargoActivityDriverResponse } from '../models/GetCargoActivityDriverResponse';
import type { GetCargoActivitySummaryDriverResponse } from '../models/GetCargoActivitySummaryDriverResponse';
import type { Pagination1OfCargoListedDriverDto } from '../models/Pagination1OfCargoListedDriverDto';
import type { PostCancelCargoAdminRequest } from '../models/PostCancelCargoAdminRequest';
import type { TransferCargoAdminRequest } from '../models/TransferCargoAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CargosService {
    /**
     * @returns CargoDriverDto OK
     * @throws ApiError
     */
    public static getCargoDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<CargoDriverDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/cargos/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Pagination1OfCargoListedDriverDto OK
     * @throws ApiError
     */
    public static getCargosDriver({
        fromDate,
        toDate,
        statuses,
        page,
        limit,
    }: {
        fromDate?: string,
        toDate?: string,
        statuses?: Array<CargoStatus>,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfCargoListedDriverDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/cargos',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
                'statuses': statuses,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetCargoActivitySummaryDriverResponse OK
     * @throws ApiError
     */
    public static getCargoActivitySummaryDriver({
        fromDate,
        toDate,
    }: {
        fromDate?: string,
        toDate?: string,
    }): CancelablePromise<GetCargoActivitySummaryDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/cargos/activity-summary',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetCargoActivityDriverResponse OK
     * @throws ApiError
     */
    public static getCargoActivityDriver({
        fromDate,
        toDate,
    }: {
        fromDate?: string,
        toDate?: string,
    }): CancelablePromise<GetCargoActivityDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/cargos/activity',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrderDetails`
     * @returns CargoAdminDto OK
     * @throws ApiError
     */
    public static getCargoAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<CargoAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cargos/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns CargoAdminDto OK
     * @throws ApiError
     */
    public static postCancelCargoAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostCancelCargoAdminRequest,
    }): CancelablePromise<CargoAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/cargos/{id}/cancel',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns any OK
     * @throws ApiError
     */
    public static postTransferCargoAndAcquireAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: TransferCargoAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/cargos/{id}/transfer-and-acquire',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMeals`
     * @returns any OK
     * @throws ApiError
     */
    public static postTransferCargoAndAssignAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: TransferCargoAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/cargos/{id}/transfer-and-assign',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
